import request from '../request/request';
import {handleRes} from '../utils/utils';


interface HandleResInterface {
    success: any,
    fail: any,
    msg?: string
}

interface GETDeviceVideoFlvInterface {
  hideFailMes: boolean
}

const GETDeviceVideoFlv = (params: any, config?: GETDeviceVideoFlvInterface): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.GETDeviceVideoFlv({
          ...params,
          from: "omc"
        });
        const option = {
          failMes: res.msg,
        }

        if(config && config.hideFailMes){
          option.failMes = undefined
        }
        const result = handleRes(res, option);
        resolve({
          ...result,
          msg: res.msg
        });
    });
};

const PUTDeviceVideoFlv = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.PUTDeviceVideoFlv(params,);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};

// ping 心跳

const sendDeviceVideoFlvHeart = (params: any): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
    const res = await request.POSTDeviceVideoFlvHeart(params, {
      ignoreError: true
    });
    const result = handleRes(res);
    resolve(result);
  });
};

const GETDeviceVideoPlayStatus = (): Promise<HandleResInterface> => {
  return new Promise(async (resolve) => {
      const res = await request.GETRtpPlayStatus({});
      const option = {
        failMes: res.msg,
      }
      const result = handleRes(res, option);
      resolve({
        ...result,
        msg: res.msg
      });
  });
};

export {
    GETDeviceVideoFlv,
    PUTDeviceVideoFlv,
    sendDeviceVideoFlvHeart,
    GETDeviceVideoPlayStatus
};
